import React, { useMemo, useState } from 'react';
import { Block, Status } from './types';
import { createBlocks, TOTAL_BLOCKS } from './utils/blocks';
import { EntryRow } from './components/EntryRow';
import { ResultsOverlay } from './components/ResultsOverlay';
export function App() {
  const [blocks, setBlocks] = useState<Block[]>(() => createBlocks());
  const [overlayOpen, setOverlayOpen] = useState(false);
  const stats = useMemo(() => {
    const completados = blocks.filter(b => b.status).length;
    const crecH = blocks.filter(b => b.status === 'crecimiento').length * 0.5;
    const fugaH = blocks.filter(b => b.status === 'fuga').length * 0.5;
    const fillPct = Math.round(completados / TOTAL_BLOCKS * 100);
    return {
      completados,
      crecH,
      fugaH,
      fillPct
    };
  }, [blocks]);
  const allComplete = stats.completados >= TOTAL_BLOCKS;
  const handleActivityChange = (id: number, value: string) => {
    setBlocks(prev => prev.map(b => b.id === id ? {
      ...b,
      activity: value
    } : b));
  };
  const handleStatusToggle = (id: number, status: Exclude<Status, null>) => {
    setBlocks(prev => prev.map(b => b.id === id ? {
      ...b,
      status: b.status === status ? null : status
    } : b));
  };
  const handleReset = () => {
    if (window.confirm('¿Borrar todo el registro y empezar de nuevo?')) {
      setBlocks(createBlocks());
      setOverlayOpen(false);
      window.scrollTo(0, 0);
    }
  };
  const handleVerDiagnostico = () => {
    setOverlayOpen(true);
    window.scrollTo(0, 0);
  };
  return <div className="w-full min-h-screen bg-[var(--papel)] pb-[120px]" data-id="element-0" data-mp="33myix65o2dr0">
      {/* HERO */}
      <header className="relative overflow-hidden bg-[var(--negro)] text-[var(--papel)] px-6 pt-11 pb-[34px] sm:px-[calc((100%-560px)/2+16px)]" data-id="element-1" data-mp="38kgl8dp6huq1">
        <p className="font-mono-jb text-[11.5px] tracking-[0.14em] uppercase text-[var(--dorado)] m-0 mb-3.5" data-id="element-2" data-mp="nwc39wy9i3yd">
          Mapa de Fugas · Diagnóstico
        </p>
        <h1 className="font-serif-fr font-semibold text-[30px] leading-[1.18] m-0 mb-3 max-w-[20ch]" data-id="element-3" data-mp="swgmhuqk1csa">
          ¿A dónde se van tus horas?
        </h1>
        <p className="text-[14.5px] leading-[1.55] text-[rgba(247,243,233,0.72)] m-0 mb-5 max-w-[42ch]" data-id="element-4" data-mp="3ubri4mbn8k51">
          Registra cada bloque de tu día, de 6:00am a 10:00pm. Anota qué hiciste y marca si esa
          actividad te generó crecimiento real o si fue una fuga. Al final vas a ver, en números,
          cuánto tiempo se te está yendo.
        </p>
        <div className="flex gap-[22px] mt-[22px] font-mono-jb" data-id="element-5" data-mp="3bmbe3p0r29jv">
          <div className="flex flex-col" data-id="element-6" data-mp="3bnurn7v0u6hy">
            <span className="text-xl text-[var(--papel)] font-bold" data-id="element-7" data-mp="3qaxs9nen4v9i">
              {stats.completados}/{TOTAL_BLOCKS}
            </span>
            <span className="text-[10px] text-[var(--gris)] uppercase tracking-[0.08em] mt-0.5" data-id="element-8" data-mp="3ljphoo1kr3ur">
              Bloques
            </span>
          </div>
          <div className="flex flex-col" data-id="element-9" data-mp="2svtm5mnqrhzk">
            <span className="text-xl text-[var(--papel)] font-bold" data-id="element-10" data-mp="2suquvdmibdj4">
              {stats.crecH.toFixed(1)}h
            </span>
            <span className="text-[10px] text-[var(--gris)] uppercase tracking-[0.08em] mt-0.5" data-id="element-11" data-mp="18cgfzx81o9n8">
              Crecimiento
            </span>
          </div>
          <div className="flex flex-col" data-id="element-12" data-mp="ygd3pyjhaumk">
            <span className="text-xl text-[var(--papel)] font-bold" data-id="element-13" data-mp="yhencrek8pfw">
              {stats.fugaH.toFixed(1)}h
            </span>
            <span className="text-[10px] text-[var(--gris)] uppercase tracking-[0.08em] mt-0.5" data-id="element-14" data-mp="1r495virtheqq">
              Fuga
            </span>
          </div>
        </div>
        {/* progress fill */}
        <div className="absolute left-0 bottom-0 h-1.5 bg-[var(--dorado)] transition-[width] duration-500 ease-out" style={{
        width: `${stats.fillPct}%`
      }} aria-hidden="true" data-id="element-15" data-mp="1i3kuywxpzui2" />
        <div className="absolute left-0 right-0 bottom-0 h-1.5 bg-[rgba(255,255,255,0.08)] -z-0" aria-hidden="true" data-id="element-16" data-mp="6onpydl54up2" />
      </header>

      {/* LEDGER */}
      <main className="px-4 pt-[26px] sm:max-w-[560px] sm:mx-auto" data-id="element-17" data-mp="qx5gbyel6oah">
        <div className="flex justify-between items-baseline border-b-2 border-[var(--negro)] pb-2 mb-0.5" data-id="element-18" data-mp="qygjpx44du12">
          <h2 className="font-serif-fr font-semibold italic text-[17px] m-0" data-id="element-19" data-mp="m544uep8t1li">Registro del día</h2>
          <span className="font-mono-jb text-[10.5px] text-[var(--gris)] uppercase tracking-[0.06em]" data-id="element-20" data-mp="h7lzszecj6is">
            Debe / Haber
          </span>
        </div>
        <div data-id="element-21" data-mp="19w9ol4yb0e13">
          {blocks.map(b => <EntryRow key={b.id} block={b} onActivityChange={handleActivityChange} onStatusToggle={handleStatusToggle} data-id="element-22" data-mp="19tx5upkq1zmz" />)}
        </div>
      </main>

      {/* STICKY BAR */}
      <div className="fixed left-0 right-0 bottom-0 bg-[var(--negro)] text-[var(--papel)] px-4 py-[13px] pb-[calc(13px+env(safe-area-inset-bottom))] flex items-center justify-between gap-3 shadow-[0_-6px_18px_rgba(0,0,0,0.18)] z-20 sm:px-[calc((100%-560px)/2+16px)]" data-id="element-23" data-mp="vx09y9pqxrz8">
        <div className="font-mono-jb text-[11.5px] text-[rgba(247,243,233,0.75)]" data-id="element-24" data-mp="1w4ezsdi9wtib">
          Completados: <b className="text-[var(--dorado)] text-[13px]" data-id="element-25" data-mp="2060cnyut57si">{stats.completados}</b>/
          {TOTAL_BLOCKS}
        </div>
        <button onClick={handleVerDiagnostico} disabled={!allComplete} className={`border-none px-[18px] py-[11px] rounded-[3px] font-bold text-[13px] whitespace-nowrap ${allComplete ? 'bg-[var(--dorado)] text-[var(--negro)] cursor-pointer' : 'bg-[#4a463d] text-[#8C8577] cursor-not-allowed'}`} data-id="element-26" data-mp="254lf84xj83k4">
          {allComplete ? 'Ver mi diagnóstico' : `Faltan ${TOTAL_BLOCKS - stats.completados} bloques`}
        </button>
      </div>

      <ResultsOverlay open={overlayOpen} blocks={blocks} onClose={() => setOverlayOpen(false)} onReset={handleReset} data-id="element-27" data-mp="2stwhjquj660d" />
    </div>;
}